var app = angular.module("leonardo");

var ReportsListFilters = function (
  $scope,
  $rootScope,
  $controller,
  $timeout,
  ReportService,
  TemplateService,
  CategoryRestService,
  SubCategoryRestService,
  AccountUserService
) {

  $controller('ReportsFilters', { $scope: $scope });

  $scope.filters_valid = ReportService.filtersActionItem;

  $scope.group_options.push({id: 'managed_by', name: 'Managed By'});

  $scope.filters_options = [];

  $scope.initOptions = function () {
    $scope.filters_options = $scope.filters_base.concat([
      {
        id: 'name',
        name: 'Action Item Name',
        label: 'Tasks Name Contains',
        inline: false,
        type: 'text',
        placeholder: 'Action Item Name',
        condition: true,
        conflicts: [],
        onSubmit: $scope.display
      },
      {
        id: 'notes_text',
        name: 'Action Item Note',
        label: 'Note Text Contains',
        inline: false,
        type: 'text',
        placeholder: 'Action Item Note',
        condition: true,
        conflicts: [],
        onSubmit: $scope.display
      },
      {
        id: 'notes_include',
        name: 'Has notes',
        label: 'Notes Include',
        help: 'Include only those items that have written notes',
        inline: false,
        type: 'checkbox',
        condition: true,
        conflicts: []
      },
      {
        id: 'notes_important',
        name: 'Notes marked important',
        label: 'Notes Important',
        help: 'Include only those items where the note was marked as important',
        inline: false,
        type: 'checkbox',
        condition: true,
        conflicts: []
      },
      {
        id: 'report_users',
        name: 'User(s)',
        label: 'User(s)',
        inline: false,
        type: 'options',
        multiple: true,
        modeUser: true,
        placeholder: 'All Users',
        condition: true,
        service: AccountUserService,
        conflicts: []
      },
      {
        id: 'recurrence_type',
        name: 'Recurrence',
        label: 'Recurrence',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All Recurrences',
        condition: true,
        options: TemplateService.RECURRENCE_OPTIONS,
        conflicts: []
      },
      {
        id: 'priority',
        name: 'Priority',
        label: 'Priority',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All Priorities',
        condition: true,
        options: ReportService.PRIORITY_OPTIONS,
        conflicts: []
      },
      {
        id: 'status',
        name: 'Status',
        label: 'Status',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All Status',
        condition: true,
        options: ReportService.STATUS_OPTIONS,
        conflicts: []
      },
      {
        id: 'not_past_due',
        name: 'Not Past Due',
        label: 'Not Past Due',
        inline: false,
        type: 'checkbox',
        condition: true,
        conflicts: []
      },
      {
        id: 'completed_on_due',
        name: 'Completed On Due',
        label: 'Completed On Due',
        inline: false,
        type: 'checkbox',
        condition: true,
        conflicts: []
      },
      {
        id: 'snoozed',
        name: 'Only Snoozed',
        label: 'Snoozed',
        inline: false,
        type: 'checkbox',
        condition: true,
        conflicts: []
      },
      {
        id: 'category',
        name: 'Category',
        label: 'Category',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All Categories',
        condition: true,
        service: CategoryRestService,
        conflicts: ['sector']
      },
      {
        id: 'subcategory',
        name: 'Subcategory',
        label: 'Subcategory',
        inline: false,
        type: 'options',
        multiple: true,
        placeholder: 'All Subcategories',
        condition: true,
        service: SubCategoryRestService,
        conflicts: ['sector']
      },
      {
        id: 'fields_active',
        name: 'Fields To Show',
        label: 'Fields To Show',
        inline: false,
        type: 'columns',
        placeholder: 'Select Fields',
        condition: true,
        options: ReportService.fieldsReport,
        requiredFields: ['action_item'],
        conflicts: []
      },
      {
        id: 'extra_fields',
        name: 'Database IDs To Show',
        label: 'Database IDs To Show',
        inline: false,
        type: 'columns',
        placeholder: 'Select Fields',
        condition: true,
        options: ReportService.actionItemsIdFields,
        conflicts: []
      }
    ]);
  };

  $scope.initOptions();

  if ($scope.filters_name !== 'filters_report') {
    var filters = $scope.filterService.hasFilter($scope.filters_name) ? $scope.filterService.getFilter($scope.filters_name) : [];

    if (!angular.isArray(filters)) {
      filters = filters.split(',');
    }

    if (!$scope.filterService.hasFilter('property_reports') && !ReportService.quick_report) {
      if (!_.contains(filters,'property_reports')) {
        filters.unshift('property_reports');
      }
    }

    angular.forEach($scope.filterService.filters, function(value, key) {
      if (!_.contains(filters, key) && $scope.isValid(key)) {
        filters.push(key);
      }
    });

    if (!$scope.filterService.hasFilter('status') && !ReportService.quick_report) {
      if (!_.contains(filters,'status')) {
        filters.push('status');
      }
    }

    $scope.filterService.setFilter($scope.filters_name, filters, true);
    $rootScope.$broadcast('filters-report:initialized');
  }

  $timeout(function() {
    $rootScope.$broadcast('validFilters:updated', $scope.getValidFilters);
    $rootScope.$broadcast('filters-valid:updated', $scope.filters_valid);
    $rootScope.$broadcast('report-type:updated', ReportService.TYPE_ACTION_ITEM);
  }, 100);

};

app.controller('ReportsListFilters', [
  '$scope',
  '$rootScope',
  '$controller',
  '$timeout',
  'ReportService',
  'TemplateService',
  'CategoryRestService',
  'SubCategoryRestService',
  'AccountUserService',
  ReportsListFilters
]);
